// Mock data for José Manuel Antonio Olvera Sousa's portfolio

export const portfolioData = {
  personalInfo: {
    name: "José Manuel Antonio Olvera Sousa",
    title: "Agribusiness Innovation & Supply Chain Transformation Leader",
    tagline: "Delivering agribusiness innovation & supply chain transformation | 37+ yrs leading productive teams | Expert in disruptive solutions, precision & regenerative agriculture | Trusted advisor for entrepreneurs & directors in México",
    location: "Guadalajara, Jalisco, México",
    email: "jomanolveras@gmail.com",
    phone: "(52) 3339361940",
    linkedin: "https://www.linkedin.com/in/jos%C3%A9-manuel-antonio-olvera-sousa-7637811b/",
    profileImage: null // User will upload their own
  },

  about: {
    description: "Con más de 37 años de liderazgo práctico en agronegocios y operaciones de cadena de suministro, me especializo en integrar trabajo de campo, experiencia técnica e innovación para obtener resultados en sistemas extensivos de cultivo y laboratorios avanzados de cultivo de tejidos vegetales. Reconocido por construir equipos multidisciplinarios de alto rendimiento e implementar soluciones transformadoras, mi trabajo abarca agave, maíz, cebada y prácticas pioneras en agricultura regenerativa en todo México.",
    mission: "Mi enfoque combina gestión de riesgos, mejora de procesos basada en datos y una pasión por desarrollar talento interno, entregando impacto medible para empresarios, CEOs y líderes agronómicos que enfrentan entornos complejos y cambiantes rápidamente.",
    highlights: [
      "Lideré equipos desde trabajadores de campo hasta supervisores, superando consistentemente las metas de productividad",
      "Construí y gestioné laboratorios de cultivo de tejidos vegetales de alta tecnología para micropropagación",
      "Implementé sistemas ERP, drones, agro-meteorológicos y de agricultura de precisión incrementando eficiencia y transparencia",
      "Impulsé mejora continua, certificaciones ISO 9001 y soy Six Sigma Black Belt",
      "Apoyé a empresarios del agronegocio con estrategias accionables y facilitación para sinergias",
      "Fomenté una cultura de innovación integrando oportunidades disruptivas y prácticas sustentables"
    ]
  },

  experience: [
    {
      id: 1,
      position: "Sr. Innovation Manager",
      company: "Clase Azul México",
      location: "Jalisco",
      period: "2022–2024",
      description: "Lideré despliegue de ERP, drones y sistemas de teledetección para aumentar transparencia y confiabilidad en operaciones de agave.",
      achievements: [
        "Implementé ERP TOTVS en operaciones de campo",
        "Gestioné flota de drones DJI T40 y red agro-meteorológica de 18 estaciones",
        "Reducción de riesgos laborales en campo",
        "Mayor velocidad de toma de decisiones",
        "Incrementé eficiencia operativa en 35%"
      ]
    },
    {
      id: 2,
      position: "Regional Production Manager",
      company: "Grupo Modelo",
      location: "Guanajuato",
      period: "2016–2018",
      description: "Coordiné producción anual de 250,000+ toneladas y lideré equipo agronómico para 35,000 ha con agricultura sostenible y de precisión.",
      achievements: [
        "Integré herramientas de agricultura de precisión",
        "Desarrollo de talento y proyectos de sustentabilidad",
        "Suministro asegurado para plantas cerveceras",
        "Aumenté rendimientos en campo 28%",
        "Mejoré eficiencia hídrica y nitrogenada para programas Smart Barley"
      ]
    },
    {
      id: 3,
      position: "Consultor",
      company: "Servicios de Gestión Integral",
      location: "Oeste México",
      period: "2013–2015",
      description: "Diagnostiqué y mejoré procesos de negocio y desarrollo de talento en cadena de suministro y agronegocios.",
      achievements: [
        "Rediseñé flujos de trabajo",
        "Lideré capacitaciones y reduje factores limitantes",
        "Mejoré productividad del equipo 20%",
        "Aumenté indicadores de seguridad y ambientales"
      ]
    },
    {
      id: 4,
      position: "Coordinador ISO y Six Sigma Black Belt",
      company: "Monsanto",
      location: "México",
      period: "1994–2006",
      description: "Lideré certificación ISO 9001:2000, gestionando seguridad, calidad y mejora continua en producción de semillas.",
      achievements: [
        "Alcancé reducción de costos del 15%",
        "Aumento en capacidad de planta",
        "Reconocimiento en excelencia operativa",
        "Implementación completa de sistemas de calidad"
      ]
    }
  ],

  skills: [
    "Liderazgo en Agronomía",
    "Optimización de Cadena de Suministro",
    "Cultivo de Tejidos Vegetales",
    "Agricultura de Precisión",
    "Agricultura Regenerativa",
    "Gestión de Innovación",
    "Formación y Desarrollo de Equipos",
    "Gestión de Proyectos",
    "Implementación ERP",
    "Operación de Drones y Teledetección",
    "Certificación ISO 9001",
    "Six Sigma Black Belt",
    "Gestión de Riesgos",
    "Sistemas de Cultivo Sustentables",
    "Relación con Stakeholders"
  ],

  projects: [
    {
      id: 1,
      title: "Despliegue Automatizado de Drones en Campos de Agave",
      description: "Implementación de tecnología de drones DJI T40 para monitoreo y aplicación precisa en cultivos de agave.",
      image: "https://images.unsplash.com/photo-1535379453347-1ffd615e2e08?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxwcmVjaXNpb24lMjBhZ3JpY3VsdHVyZXxlbnwwfHx8fDE3NTg0OTg0MjZ8MA&ixlib=rb-4.1.0&q=85",
      tags: ["Drones", "Agricultura de Precisión", "Agave", "Teledetección"]
    },
    {
      id: 2,
      title: "Integración ERP para Operaciones Agronegocio",
      description: "Caso de estudio de implementación ERP TOTVS en operaciones de campo para mayor transparencia y eficiencia.",
      image: "https://images.unsplash.com/photo-1647268772035-85a4cf15d37a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxwcmVjaXNpb24lMjBhZ3JpY3VsdHVyZXxlbnwwfHx8fDE3NTg0OTg0MjZ8MA&ixlib=rb-4.1.0&q=85",
      tags: ["ERP", "Gestión", "Eficiencia", "Tecnología"]
    },
    {
      id: 3,
      title: "Innovaciones en Micropropagación de Agave",
      description: "Desarrollo de técnicas avanzadas de cultivo de tejidos vegetales para producción escalable de agave.",
      image: "https://images.pexels.com/photos/8851084/pexels-photo-8851084.jpeg", // Plantas micropropagadas en frascos de laboratorio
      tags: ["Biotecnología", "Cultivo de Tejidos", "Micropropagación", "Agave"]
    },
    {
      id: 4,
      title: "Agricultura Regenerativa en Sistemas Extensivos",
      description: "Implementación de prácticas regenerativas para mejorar salud del suelo y productividad sostenible.",
      image: "https://images.unsplash.com/photo-1492496913980-501348b61469?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxyZWdlbmVyYXRpdmUlMjBmYXJtaW5nfGVufDB8fHx8MTc1ODQ5ODQzNnww&ixlib=rb-4.1.0&q=85",
      tags: ["Agricultura Regenerativa", "Salud del Suelo", "Sostenibilidad", "Productividad"]
    }
  ],

  images: {
    heroBackground: "https://images.unsplash.com/photo-1505590309800-8b20b8ba273b", // Campos regenerativos aéreos organizados con árboles
    aboutSection: "https://images.pexels.com/photos/789555/pexels-photo-789555.jpeg", // Campos de cebada espigando al amanecer
    skillsSection: "https://images.pexels.com/photos/3912480/pexels-photo-3912480.jpeg",
    // Imágenes de fondo para experiencias profesionales
    claseAzulBg: "https://images.unsplash.com/photo-1634130132261-3bdf61051454?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxhZ2F2ZXxlbnwwfHx8fDE3NTg0OTk4NzF8MA&ixlib=rb-4.1.0&q=85", // Campo de agave en amanecer
    grupoModeloBg: "https://images.unsplash.com/photo-1719557362652-d68caf96df85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxiYXJsZXklMjBmaWVsZHN8ZW58MHx8fHwxNzU4NDk5ODYwfDA&ixlib=rb-4.1.0&q=85", // Campo de cebada madura al atardecer
    consultorBg: "https://images.unsplash.com/photo-1718939041087-69074ed42c23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxkaXN0aWxsZXJ5JTIwZXF1aXBtZW50fGVufDB8fHx8MTc1ODQ5OTg3N3ww&ixlib=rb-4.1.0&q=85", // Planta de destilados con equipos
    monsantoBg: "https://images.unsplash.com/photo-1684259499227-e9844ab79747?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwdGVhbXdvcmt8ZW58MHx8fHwxNzU4NDk5ODgzfDA&ixlib=rb-4.1.0&q=85" // Personal técnico en planta industrial
  }
};

export default portfolioData;